import {Navigate, useOutlet} from 'react-router-dom'
import {AppLayout} from "./appLayout";

const ProtectedLayout = (props) => {
    let user = null;
    try {
        user = JSON.parse(localStorage.getItem('concUser'));
    }
    catch (err) {
         localStorage.removeItem('concUser');
    }

    const outlet = useOutlet();

    let token = false;
    if (user && user.token && user.email) {
        token = true;
    }
    let layout;
    if (token) {
        layout = <div>
            <AppLayout
                page={props.page}
                title={props.title}
            />
            {outlet}
        </div>
    } else {
        localStorage.removeItem('concUser');
        layout = <Navigate to="/"/>
    }

    return (
        <div>
            {layout}
        </div>
    )
};

export default ProtectedLayout